<template>
  <div class="sv-page" dir="rtl">
    <div
      class="modal fade sv-modal"
      id="Modal-Setting"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="Modal-SettingLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header sv-modal__header">
            <h6 class="modal-title" id="Modal-SettingLabel">
              {{
                !$GetIsAnbohSaz() == false
                  ? "انتخاب نوع وام"
                  : "انتخاب نوع واحد"
              }}
            </h6>
          </div>
          <div class="modal-body sv-modal__body">
            <div class="sv-pick-list">
              <article
                v-for="(item, key) in Vamha"
                :key="key"
                class="sv-pick"
                :class="{ 'is-selected': SelectedVam.id == item.id }"
              >
                <div class="sv-pick__text">
                  <span class="sv-label">
                    {{
                      !$GetIsAnbohSaz() == false ? "نام تسهیلات" : "نام واحد"
                    }}
                  </span>
                  <strong>{{ item.desNoe }}</strong>
                </div>
                <button
                  v-if="SelectedVam.id != item.id"
                  type="button"
                  class="sv-btn sv-btn--primary sv-btn--sm"
                  @click="seLectVam(item)"
                >
                  انتخاب
                </button>
                <span v-else class="sv-pick__done">
                  <i class="fas fa-check" aria-hidden="true"></i>
                  انتخاب شده
                </span>
              </article>
            </div>
          </div>
          <div class="modal-footer sv-modal__footer">
            <button
              type="button"
              class="sv-btn sv-btn--ghost"
              data-dismiss="modal"
              @click="$router.go(-1)"
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade sv-modal"
      id="Modal-Copy-Setting"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="Modal-Copy-SettingLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header sv-modal__header">
            <h6 class="modal-title" id="Modal-Copy-SettingLabel">
              کپی تنظیمات {{ SelectedVam.desNoe }}
            </h6>
          </div>
          <div class="modal-body sv-modal__body">
            <p class="sv-modal__lead">
              مقادیر ذخیره‌شده این تسهیلات کپی می‌شود. بخش‌هایی را که می‌خواهید
              منتقل شود انتخاب کنید.
            </p>
            <div class="sv-copy-options">
              <label class="sv-check" :class="{ 'is-disabled': copyBusy }">
                <input
                  type="checkbox"
                  id="CopyGeneral"
                  v-model="copyGeneral"
                  :disabled="copyBusy"
                />
                <span class="sv-check__box" aria-hidden="true"></span>
                <span>تنظیمات کلی</span>
              </label>
              <label class="sv-check" :class="{ 'is-disabled': copyBusy }">
                <input
                  type="checkbox"
                  id="CopyZamen"
                  v-model="copyZamen"
                  :disabled="copyBusy"
                />
                <span class="sv-check__box" aria-hidden="true"></span>
                <span>تنظیمات شرایط ضامنین</span>
              </label>
              <p class="sv-hint">
                ردیف‌های شرایط ضامن مقصد پاک و با ردیف‌های مبدأ جایگزین می‌شوند.
                اگر فقط شرایط ضامن انتخاب شود و وام مقصد تنظیمات کلی نداشته
                باشد، کپی آن وام انجام نمی‌شود.
              </p>
            </div>
            <div class="sv-copy-head">
              <span>وام‌های مقصد</span>
              <span class="sv-copy-head__actions">
                <button
                  type="button"
                  class="sv-btn sv-btn--ghost sv-btn--sm"
                  :disabled="copyBusy"
                  @click="selectAllCopyTargets"
                >
                  انتخاب همه
                </button>
                <button
                  type="button"
                  class="sv-btn sv-btn--ghost sv-btn--sm"
                  :disabled="copyBusy"
                  @click="clearCopyTargets"
                >
                  حذف انتخاب
                </button>
              </span>
            </div>
            <div class="sv-copy-list">
              <label
                v-for="item in copyCandidates"
                :key="item.id"
                class="sv-check"
                :class="{ 'is-disabled': copyBusy }"
              >
                <input
                  type="checkbox"
                  :id="'copy-vam-' + item.id"
                  :value="item.id"
                  v-model="copyTargets"
                  :disabled="copyBusy"
                />
                <span class="sv-check__box" aria-hidden="true"></span>
                <span>{{ item.desNoe }}</span>
              </label>
              <p v-if="copyCandidates.length === 0" class="sv-hint sv-hint--empty">
                وام دیگری برای کپی وجود ندارد
              </p>
            </div>
          </div>
          <div class="modal-footer sv-modal__footer">
            <button
              type="button"
              class="sv-btn sv-btn--primary"
              :disabled="copyBusy"
              @click="submitCopy"
            >
              {{ copyBusy ? "در حال کپی..." : "انجام کپی" }}
            </button>
            <button
              type="button"
              class="sv-btn sv-btn--ghost"
              data-dismiss="modal"
              :disabled="copyBusy"
            >
              انصراف
            </button>
          </div>
        </div>
      </div>
    </div>

    <Panel
      Title="تنظیمات درخواست وام"
      Des="در این منو میتوانید تنظیمات مربوط به شرایط درخواست وام و دیگر تنظیمات آن‌را در سامانه خود را انجام دهید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></Panel>

    <div class="row px-3">
      <div class="col-12 mx-md-2 p-md-3">
        <net-pa-tab
          :Tabs="[
            { id: 'nav-home', title: 'تنظیمات کلی' },
            { id: 'nav-zamen', title: 'تنظیمات شرایط ضامنین' },
          ]"
        >
          <button
            type="button"
            class="sv-btn sv-btn--ghost sv-btn--icon"
            data-toggle="modal"
            data-target="#Modal-Setting"
            :aria-label="
              !$GetIsAnbohSaz() == false
                ? 'انتخاب نوع وام'
                : 'انتخاب نوع واحد'
            "
            :title="
              !$GetIsAnbohSaz() == false
                ? 'انتخاب نوع وام'
                : 'انتخاب نوع واحد'
            "
            @click="openModal"
          >
            <i class="fas fa-list" aria-hidden="true"></i>
          </button>
          <button
            v-if="IsSetting"
            type="button"
            class="sv-btn sv-btn--ghost"
            @click="openCopyModal"
          >
            <i class="fas fa-copy" aria-hidden="true"></i>
            کپی تنظیمات به وام دیگر
          </button>
        </net-pa-tab>
        <net-pa-card class="sv-card">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-sliders-h"></i>
              <span
                class="sv-state"
                :class="{ 'is-empty': !IsSetting }"
                role="status"
              >
                <template v-if="IsSetting">
                  تسهیلات {{ SelectedVam.desNoe }} برای تنظیمات انتخاب شد
                </template>
                <template v-else>
                  برای تسهیلات {{ SelectedVam.desNoe }} هیچ تنظیماتی انجام نشده
                </template>
              </span>
            </h6>
          </template>

          <template slot="content">
            <div class="tab-content" id="nav-tabContent">
              <!-- ============ تنظیمات کلی ============ -->
              <div
                class="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <!-- مجوزها -->
                <div
                  class="sv-section"
                  :class="{ 'is-open': svOpenSection === 'permits' }"
                >
                  <h4
                    class="sv-section__title"
                    @click="toggleSvSection('permits')"
                  >
                    <i class="fas fa-toggle-on" aria-hidden="true"></i>
                    <span>مجوزها و الزامات</span>
                    <i
                      class="fas fa-chevron-down sv-section__chevron"
                      aria-hidden="true"
                    ></i>
                  </h4>
                  <div class="sv-toggles">
                    <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                      <span class="sv-switch">
                        <input
                          type="checkbox"
                          id="IsActive"
                          v-model="DataModelSetting.IsActive"
                          :disabled="!EditMode"
                        />
                        <span class="sv-switch__track" aria-hidden="true"></span>
                      </span>
                      <span class="sv-toggle__text">مجوز برای درخواست وام</span>
                    </label>
                    <label
                      v-if="
                        IsFormulEqual == true ||
                        IsFormulEqualMin == true ||
                        IsFormolEqualhoghogh == true ||
                        IsFormulEqualMax == true
                      "
                      class="sv-toggle"
                      :class="{ 'is-disabled': !EditMode }"
                    >
                      <span class="sv-switch">
                        <input
                          type="checkbox"
                          id="IsFixInputMablaghVam"
                          v-model="DataModelSetting.IsFixInputMablaghVam"
                          :disabled="!EditMode"
                        />
                        <span class="sv-switch__track" aria-hidden="true"></span>
                      </span>
                      <span class="sv-toggle__text">عدم امکان تغییر مبلغ وام</span>
                    </label>
                    <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                      <span class="sv-switch">
                        <input
                          type="checkbox"
                          id="Isformula"
                          v-model="DataModelSetting.Isformula"
                          :disabled="!EditMode"
                        />
                        <span class="sv-switch__track" aria-hidden="true"></span>
                      </span>
                      <span class="sv-toggle__text">
                        محاسبات مبلغ و تعداد بر اساس فرمول
                      </span>
                    </label>
                    <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                      <span class="sv-switch">
                        <input
                          type="checkbox"
                          id="ischeckupMandeAllTaahodat"
                          v-model="DataModelSetting.ischeckupMandeAllTaahodat"
                          :disabled="!EditMode"
                        />
                        <span class="sv-switch__track" aria-hidden="true"></span>
                      </span>
                      <span class="sv-toggle__text">نداشتن بدهی از هر نوع وام</span>
                    </label>
                    <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                      <span class="sv-switch">
                        <input
                          type="checkbox"
                          id="IsUpload"
                          v-model="DataModelSetting.IsUpload"
                          :disabled="!EditMode"
                        />
                        <span class="sv-switch__track" aria-hidden="true"></span>
                      </span>
                      <span class="sv-toggle__text">الزام به بارگذاری مدارک</span>
                    </label>
                    <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                      <span class="sv-switch">
                        <input
                          type="checkbox"
                          id="IsSafteElectronic"
                          v-model="DataModelSetting.IsSafteElectronic"
                          :disabled="!EditMode"
                        />
                        <span class="sv-switch__track" aria-hidden="true"></span>
                      </span>
                      <span class="sv-toggle__text">
                        الزام به بررسی سفته الکترونیکی
                      </span>
                    </label>
                  </div>
                </div>

                <!-- مبلغ درخواست -->
                <div
                  class="sv-section"
                  :class="{ 'is-open': svOpenSection === 'amount' }"
                >
                  <h4
                    class="sv-section__title"
                    @click="toggleSvSection('amount')"
                  >
                    <i class="fas fa-coins" aria-hidden="true"></i>
                    <span>مبلغ درخواست</span>
                    <i
                      class="fas fa-chevron-down sv-section__chevron"
                      aria-hidden="true"
                    ></i>
                  </h4>
                  <div class="sv-rules">
                    <!-- مشتری ۹۳۲ -->
                    <div v-if="$session.get('CustCode') == 932" class="sv-rule">
                      <span class="sv-rule__name">
                        محاسبه مبلغ تسهیلات چندبرابری
                      </span>
                      <label class="sv-mode" :class="{ 'is-disabled': !EditMode }">
                        <span
                          class="sv-mode__side"
                          :class="{ 'is-active': IsFormulEqual == false }"
                        >
                          بدون فرمول
                        </span>
                        <span class="sv-switch">
                          <input
                            type="checkbox"
                            class="required"
                            id="Done"
                            @change="ChangeChkTblNoeEqual($event, IsFormulEqual)"
                            v-model="IsFormulEqual"
                            :disabled="!EditMode"
                          />
                          <span class="sv-switch__track" aria-hidden="true"></span>
                        </span>
                        <span
                          class="sv-mode__side"
                          :class="{ 'is-active': IsFormulEqual == true }"
                        >
                          بر اساس فرمول
                        </span>
                      </label>
                      <template v-if="IsFormulEqual == false">
                        <label class="sv-field sv-f--md">
                          <span class="sv-label">
                            {{
                              !$GetIsAnbohSaz() == false
                                ? "حداقل میزان درخواست"
                                : "حداقل واحد درخواستی"
                            }}
                          </span>
                          <input
                            class="3ragham"
                            :disabled="!EditMode"
                            @keyup="$PutCommatoInput()"
                            dir="ltr"
                            maxlength="20"
                            type="text"
                            v-model="DataModelSetting.MinMablagh"
                          />
                        </label>
                        <label class="sv-field sv-f--md">
                          <span class="sv-label">
                            {{
                              !$GetIsAnbohSaz() == false
                                ? "حداکثر میزان درخواست"
                                : "حداکثر واحد درخواستی"
                            }}
                          </span>
                          <input
                            class="3ragham"
                            :disabled="!EditMode"
                            @keyup="$PutCommatoInput()"
                            dir="ltr"
                            maxlength="20"
                            type="text"
                            v-model="DataModelSetting.MaxMablagh"
                          />
                        </label>
                      </template>
                      <div v-if="IsFormulEqual == true" class="sv-field sv-f--grow">
                        <span class="sv-label">حداکثر میزان درخواست</span>
                        <div class="sv-inline">
                          <input
                            class="required"
                            @keypress="$ValidNumber($event, 3, true)"
                            v-model="DataModelSetting.Equal"
                            :disabled="!EditMode"
                            dir="ltr"
                            aria-label="ضریب"
                          />
                          <span class="sv-op">برابر</span>
                          <select
                            class="Pointer required"
                            @change="ChangeTblNoeEquals"
                            v-model="DataModelSetting.tblNoeIdEqual"
                            :disabled="!EditMode"
                          >
                            <option :value="-1">-- انتخاب سپرده | حساب --</option>
                            <option
                              v-for="item in this.Hesabha"
                              :key="item.id"
                              :value="item.id"
                            >
                              {{ item.desNoe }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- سایر مشتریان -->
                    <template v-if="$session.get('CustCode') != 932">
                      <div class="sv-rule">
                        <span class="sv-rule__name">حداقل مبلغ درخواست وام</span>
                        <label class="sv-mode" :class="{ 'is-disabled': !EditMode }">
                          <span
                            class="sv-mode__side"
                            :class="{ 'is-active': IsFormulEqualMin == false }"
                          >
                            بدون فرمول
                          </span>
                          <span class="sv-switch">
                            <input
                              type="checkbox"
                              class="required"
                              id="Min"
                              @change="ChangeChkMinMaxMablagh($event, true)"
                              v-model="IsFormulEqualMin"
                              :disabled="!EditMode"
                            />
                            <span class="sv-switch__track" aria-hidden="true"></span>
                          </span>
                          <span
                            class="sv-mode__side"
                            :class="{ 'is-active': IsFormulEqualMin == true }"
                          >
                            محاسبه فرمول
                          </span>
                        </label>
                        <div v-if="IsFormulEqualMin == false" class="sv-field sv-f--md">
                          <input
                            class="3ragham"
                            :disabled="!EditMode"
                            @keyup="$PutCommatoInput()"
                            dir="ltr"
                            maxlength="20"
                            type="text"
                            aria-label="حداقل مبلغ درخواست وام"
                            v-model="DataModelSetting.MinMablagh"
                          />
                        </div>
                        <template v-if="IsFormulEqualMin == true">
                          <div class="sv-field sv-f--xs">
                            <input
                              class="required"
                              type="number"
                              v-model="DataModelSetting.EqualMin"
                              :disabled="!EditMode"
                              dir="ltr"
                              aria-label="ضریب"
                            />
                          </div>
                          <span class="sv-op">برابر مجموع</span>
                          <div class="sv-field sv-f--grow">
                            <span class="sv-label">
                              انتخاب حساب ها جهت محاسبه مجموع موجودی
                            </span>
                            <treeselect
                              :disabled="!EditMode"
                              v-model="value"
                              :multiple="true"
                              :options="options"
                              name="Min"
                            />
                          </div>
                        </template>
                      </div>

                      <div v-if="$session.get('CustCode') == '259'" class="sv-rule">
                        <span class="sv-rule__name">حداکثر مبلغ درخواست وام</span>
                        <label class="sv-mode" :class="{ 'is-disabled': !EditMode }">
                          <span
                            class="sv-mode__side"
                            :class="{ 'is-active': IsFormolEqualhoghogh == false }"
                          >
                            بدون فرمول
                          </span>
                          <span class="sv-switch">
                            <input
                              type="checkbox"
                              class="required"
                              id="Max"
                              @change="ChangeChkMinMaxMablagh($event, false)"
                              v-model="IsFormolEqualhoghogh"
                              :disabled="!EditMode"
                            />
                            <span class="sv-switch__track" aria-hidden="true"></span>
                          </span>
                          <span
                            class="sv-mode__side"
                            :class="{ 'is-active': IsFormolEqualhoghogh == true }"
                          >
                            محاسبه فرمول
                          </span>
                        </label>
                        <div
                          v-if="IsFormolEqualhoghogh == false"
                          class="sv-field sv-f--md"
                        >
                          <input
                            class="3ragham"
                            :disabled="!EditMode"
                            @keyup="$PutCommatoInput()"
                            dir="ltr"
                            maxlength="20"
                            type="text"
                            aria-label="حداکثر مبلغ درخواست وام"
                            v-model="DataModelSetting.MaxMablagh"
                          />
                        </div>
                        <template v-if="IsFormolEqualhoghogh == true">
                          <div class="sv-field sv-f--xs">
                            <input
                              class="required"
                              type="number"
                              v-model="DataModelSetting.EqualHoghogh"
                              :disabled="!EditMode"
                              dir="ltr"
                              aria-label="ضریب"
                            />
                          </div>
                          <span class="sv-op">برابر</span>
                          <span class="sv-op sv-op--strong">مبلغ حقوق پایه</span>
                        </template>
                      </div>

                      <div v-else class="sv-rule">
                        <span class="sv-rule__name">حداکثر مبلغ درخواست وام</span>
                        <label class="sv-mode" :class="{ 'is-disabled': !EditMode }">
                          <span
                            class="sv-mode__side"
                            :class="{ 'is-active': IsFormulEqualMax == false }"
                          >
                            بدون فرمول
                          </span>
                          <span class="sv-switch">
                            <input
                              type="checkbox"
                              class="required"
                              id="Max"
                              @change="ChangeChkMinMaxMablagh($event, false)"
                              v-model="IsFormulEqualMax"
                              :disabled="!EditMode"
                            />
                            <span class="sv-switch__track" aria-hidden="true"></span>
                          </span>
                          <span
                            class="sv-mode__side"
                            :class="{ 'is-active': IsFormulEqualMax == true }"
                          >
                            محاسبه فرمول
                          </span>
                        </label>
                        <div v-if="IsFormulEqualMax == false" class="sv-field sv-f--md">
                          <input
                            class="3ragham"
                            :disabled="!EditMode"
                            @keyup="$PutCommatoInput()"
                            dir="ltr"
                            maxlength="20"
                            type="text"
                            aria-label="حداکثر مبلغ درخواست وام"
                            v-model="DataModelSetting.MaxMablagh"
                          />
                        </div>
                        <template v-if="IsFormulEqualMax == true">
                          <div class="sv-field sv-f--xs">
                            <input
                              class="required"
                              type="number"
                              v-model="DataModelSetting.EqualMax"
                              :disabled="!EditMode"
                              dir="ltr"
                              aria-label="ضریب"
                            />
                          </div>
                          <span class="sv-op">برابر مجموع</span>
                          <div class="sv-field sv-f--grow">
                            <span class="sv-label">
                              انتخاب حساب ها جهت محاسبه مجموع موجودی
                            </span>
                            <treeselect
                              :disabled="!EditMode"
                              v-model="valueMax"
                              :multiple="true"
                              :options="optionsMax"
                              name="Max"
                            />
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>

                <!-- اقساط و بدهی -->
                <div
                  class="sv-section"
                  :class="{ 'is-open': svOpenSection === 'debt' }"
                >
                  <h4 class="sv-section__title" @click="toggleSvSection('debt')">
                    <i class="fas fa-list-ol" aria-hidden="true"></i>
                    <span>اقساط و سقف بدهی</span>
                    <i
                      class="fas fa-chevron-down sv-section__chevron"
                      aria-hidden="true"
                    ></i>
                  </h4>
                  <div class="sv-fields">
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">حداقل تعداد اقساط درخواستی</span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.MinTedad"
                      />
                    </label>
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">حداکثر تعداد اقساط درخواستی</span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.MaxTedad"
                      />
                    </label>
                    <div class="sv-field">
                      <span class="sv-label">
                        محاسبه حداکثر میزان بدهی از این نوع وام
                      </span>
                      <label class="sv-mode" :class="{ 'is-disabled': !EditMode }">
                        <span
                          class="sv-mode__side"
                          :class="{ 'is-active': !IsFormolMaxBedehi }"
                        >
                          بر اساس مبلغ
                        </span>
                        <span class="sv-switch">
                          <input
                            type="checkbox"
                            class="required"
                            id="MaxBedehi"
                            v-model="IsFormolMaxBedehi"
                            :disabled="!EditMode"
                          />
                          <span class="sv-switch__track" aria-hidden="true"></span>
                        </span>
                        <span
                          class="sv-mode__side"
                          :class="{ 'is-active': IsFormolMaxBedehi }"
                        >
                          بر اساس تعداد قسط
                        </span>
                      </label>
                    </div>
                    <label
                      v-if="!IsFormolMaxBedehi && !$GetIsAnbohSaz() == false"
                      class="sv-field sv-f--md"
                    >
                      <span class="sv-label">حداکثر مبلغ بدهی از این نوع وام</span>
                      <input
                        class="3ragham"
                        :disabled="!EditMode"
                        @keyup="$PutCommatoInput()"
                        dir="ltr"
                        maxlength="20"
                        type="text"
                        v-model="DataModelSetting.MaxBedeh"
                      />
                    </label>
                    <label v-if="IsFormolMaxBedehi" class="sv-field sv-f--xs">
                      <span class="sv-label">حداکثر تعداد قسط باقی مانده</span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.MaxTedadGhestBedeh"
                      />
                    </label>
                  </div>
                </div>

                <!-- سابقه و موجودی -->
                <div
                  class="sv-section"
                  :class="{ 'is-open': svOpenSection === 'account' }"
                >
                  <h4
                    class="sv-section__title"
                    @click="toggleSvSection('account')"
                  >
                    <i class="fas fa-university" aria-hidden="true"></i>
                    <span>سابقه و موجودی حساب</span>
                    <i
                      class="fas fa-chevron-down sv-section__chevron"
                      aria-hidden="true"
                    ></i>
                  </h4>
                  <div class="sv-fields">
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">حداقل ماه سابقه عضویت</span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.SabeghehOzviyat"
                      />
                    </label>
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">حداقل ماه - از افتتاح حساب</span>
                      <input
                        type="number"
                        :disabled="!EditMode"
                        dir="ltr"
                        v-model="DataModelSetting.MinMahAzEftetahHesab"
                        @keypress="$ValidNumber($event, 2, false)"
                      />
                    </label>
                    <label class="sv-field sv-f--lg">
                      <span class="sv-label">انتخاب نوع حساب</span>
                      <select
                        class="Pointer"
                        v-model="DataModelSetting.tblnoeEftetahHesab"
                        :disabled="!EditMode"
                        @change="ChangeNoeEftetahHesab()"
                      >
                        <option :value="-1">-- انتخاب حساب --</option>
                        <option
                          v-for="item in this.Hesabha"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.desNoe }}
                        </option>
                      </select>
                    </label>
                    <label class="sv-field sv-f--lg">
                      <span class="sv-label">بررسی موجودی حساب</span>
                      <select
                        class="Pointer"
                        v-model="DataModelSetting.TblNoeIdPas"
                        :disabled="!EditMode"
                        @change="ChangeNoe()"
                      >
                        <option :value="-1">-- انتخاب حساب --</option>
                        <option
                          v-for="item in this.Hesabha"
                          :key="item.id"
                          :value="item"
                        >
                          {{ item.desNoe }}
                        </option>
                      </select>
                    </label>
                    <label
                      v-if="
                        DataModelSetting.TblNoeIdPas != -1 &&
                        DataModelSetting.TblNoeIdPas != null
                      "
                      class="sv-field sv-f--md"
                    >
                      <span class="sv-label">
                        حداقل موجودی حساب
                        <span class="sv-unit">{{ $GetVahedPool() }}</span>
                      </span>
                      <input
                        class="3ragham"
                        :disabled="!EditMode"
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataModelSetting.MinMojodiPas"
                      />
                    </label>
                    <label class="sv-field sv-f--md">
                      <span class="sv-label">حداکثر بودجه ماهیانه</span>
                      <input
                        class="3ragham"
                        :disabled="!EditMode"
                        @keyup="$PutCommatoInput()"
                        dir="ltr"
                        maxlength="20"
                        type="text"
                        v-model="DataModelSetting.MaxBodjeMahane"
                      />
                    </label>
                  </div>
                </div>

                <!-- زمان و تسویه -->
                <div
                  class="sv-section"
                  :class="{ 'is-open': svOpenSection === 'period' }"
                >
                  <h4
                    class="sv-section__title"
                    @click="toggleSvSection('period')"
                  >
                    <i class="fas fa-calendar-check" aria-hidden="true"></i>
                    <span>بازه درخواست و تسویه</span>
                    <i
                      class="fas fa-chevron-down sv-section__chevron"
                      aria-hidden="true"
                    ></i>
                  </h4>
                  <div class="sv-fields">
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">محدوده درخواست از روز</span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.AzDay"
                      />
                    </label>
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">محدوده درخواست تا روز</span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.TaDay"
                      />
                    </label>
                    <label class="sv-field sv-f--xs">
                      <span class="sv-label">
                        حداقل ماه از تسویه وام قبلی گذشته باشد
                      </span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.MinMahAzTasvieHaminNoe"
                      />
                    </label>
                    <label
                      v-if="
                        $session.get('CustCode') == 259 ||
                        $session.get('CustCode') == 8002
                      "
                      class="sv-field sv-f--xs"
                    >
                      <span class="sv-label">
                        حداقل درصد از تسویه وام قبلی گذشته باشد
                      </span>
                      <input
                        :disabled="!EditMode"
                        dir="ltr"
                        maxlength="3"
                        type="text"
                        v-model="DataModelSetting.MinDarsadAzTasvieHaminNoe"
                        v-mask="'##%'"
                      />
                    </label>
                  </div>
                  <div class="sv-fields sv-fields--pair">
                    <div
                      v-if="
                        $session.get('CustCode') == 259 ||
                        $session.get('CustCode') == 8002
                      "
                      class="sv-field sv-f--grow"
                    >
                      <span class="sv-label">
                        انتخاب تسهیلات ها جهت محاسبه درصد موجودی
                      </span>
                      <treeselect
                        :disabled="!EditMode"
                        v-model="valueDarsad"
                        :multiple="true"
                        :options="optionsDarsad"
                        name="Darsad"
                      />
                    </div>
                    <div class="sv-field sv-f--grow">
                      <span class="sv-label">
                        انتخاب تسهیلات هایی که نباید درخواست فعال داشته باشند
                      </span>
                      <treeselect
                        :disabled="!EditMode"
                        v-model="valueTashilatNotMojaz"
                        :multiple="true"
                        :options="optionsDarsad"
                        name="TaahodatNotMojaz"
                      />
                    </div>
                  </div>
                </div>

                <!-- توضیحات -->
                <div
                  class="sv-section"
                  :class="{ 'is-open': svOpenSection === 'notes' }"
                >
                  <h4
                    class="sv-section__title"
                    @click="toggleSvSection('notes')"
                  >
                    <i class="fas fa-align-right" aria-hidden="true"></i>
                    <span>شرایط و توضیحات</span>
                    <i
                      class="fas fa-chevron-down sv-section__chevron"
                      aria-hidden="true"
                    ></i>
                  </h4>
                  <div class="sv-fields sv-fields--pair">
                    <label class="sv-field sv-f--grow">
                      <span class="sv-label">شرایط بارگذاری مدارک</span>
                      <textarea
                        :disabled="!EditMode"
                        rows="3"
                        v-model="DataModelSetting.DesUpload"
                      ></textarea>
                    </label>
                    <label class="sv-field sv-f--grow">
                      <span class="sv-label">
                        {{
                          !$GetIsAnbohSaz() == false
                            ? "شرایط دریافت تسهیلات"
                            : "شرایط دریافت واحد"
                        }}
                      </span>
                      <textarea
                        :disabled="!EditMode"
                        rows="3"
                        v-model="DataModelSetting.Des"
                      ></textarea>
                    </label>
                  </div>
                </div>
              </div>

              <!-- ============ شرایط ضامنین ============ -->
              <div
                class="tab-pane fade"
                id="nav-zamen"
                role="tabpanel"
                aria-labelledby="nav-zamen-tab"
              >
                <div class="sv-zamen">
                  <div v-if="addZamen == false" class="sv-zamen__bar">
                    <button
                      type="button"
                      class="sv-btn sv-btn--ghost"
                      :disabled="!EditMode"
                      @click="addZamen = true"
                    >
                      <i class="fas fa-plus" aria-hidden="true"></i>
                      اضافه کردن
                    </button>
                  </div>

                  <div v-if="addZamen == false" class="sv-zamen-list">
                    <p v-if="!rows.length" class="sv-zamen-empty">
                      موردی برای نمایش وجود ندارد
                    </p>
                    <div v-else class="sv-zamen-cards" dir="rtl">
                      <article
                        v-for="(row, index) in rows"
                        :key="(row.id || 'zamen') + '-' + index"
                        class="sv-zamen-card"
                      >
                        <div class="sv-zamen-card__header">
                          <strong class="sv-zamen-card__name">
                            {{ $Comma3ragham(row.mabAz) }}
                            تا
                            {{ $Comma3ragham(row.mabTa) }}
                          </strong>
                          <span class="sv-zamen-card__badge"
                            >{{ row.tedad || 0 }} ضامن</span
                          >
                        </div>
                        <div class="sv-zamen-card__fields">
                          <div class="sv-zamen-card__field">
                            <span>از مبلغ تسهیلات</span>
                            <strong dir="ltr">{{
                              $Comma3ragham(row.mabAz) || "—"
                            }}</strong>
                          </div>
                          <div class="sv-zamen-card__field">
                            <span>تا مبلغ تسهیلات</span>
                            <strong dir="ltr">{{
                              $Comma3ragham(row.mabTa) || "—"
                            }}</strong>
                          </div>
                          <div class="sv-zamen-card__field">
                            <span>تعداد ضامنین</span>
                            <strong dir="ltr">{{ row.tedad || "—" }}</strong>
                          </div>
                          <div class="sv-zamen-card__field">
                            <span>سقف تعداد ضمانت</span>
                            <strong dir="ltr">{{
                              row.maxCountForZemanat || "—"
                            }}</strong>
                          </div>
                          <div class="sv-zamen-card__field">
                            <span>عضویت ضامن</span>
                            <strong
                              :class="row.isOzv ? 'is-on' : 'is-off'"
                            >
                              {{ row.isOzv ? "فعال" : "غیرفعال" }}
                            </strong>
                          </div>
                          <div class="sv-zamen-card__field">
                            <span>الزام بارگذاری مدارک</span>
                            <strong
                              :class="row.isUpload ? 'is-on' : 'is-off'"
                            >
                              {{ row.isUpload ? "فعال" : "غیرفعال" }}
                            </strong>
                          </div>
                        </div>
                        <div class="sv-zamen-card__actions">
                          <button
                            type="button"
                            class="sv-zamen-chip"
                            :disabled="!EditMode"
                            @click="OnDelete(row)"
                          >
                            <i class="fa fa-trash-alt" aria-hidden="true"></i>
                            حذف
                          </button>
                        </div>
                      </article>
                    </div>
                    <div class="sv-table">
                    <vue-bootstrap4-table
                      :rows="rows"
                      :action="true"
                      :columns="columns"
                      :config="config"
                      :classes="classes"
                    >
                      <template slot="isOzv" slot-scope="props">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input InputText"
                            :checked="props.cell_value"
                            id="checkTest"
                            disabled
                          />
                          <label
                            class="custom-control-label"
                            for="checkTest"
                          ></label>
                        </div>
                      </template>
                      <template slot="isUpload" slot-scope="props">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input InputText"
                            :checked="props.cell_value"
                            id="checkTest"
                            disabled
                          />
                          <label
                            class="custom-control-label"
                            for="checkTest"
                          ></label>
                        </div>
                      </template>
                      <template slot="mabAz" slot-scope="props">
                        <p class="text-center">
                          {{ $Comma3ragham(props.row.mabAz) }}
                        </p>
                      </template>
                      <template slot="mabTa" slot-scope="props">
                        <p class="text-center">
                          {{ $Comma3ragham(props.row.mabTa) }}
                        </p>
                      </template>
                      <template slot="sort-asc-icon">
                        <i class="fa fa-sort-up"></i>
                      </template>
                      <template slot="sort-desc-icon">
                        <i class="fa fa-sort-down"></i>
                      </template>
                      <template slot="no-sort-icon">
                        <i class="fa fa-sort"></i>
                      </template>
                      <template slot="empty-results">
                        <p class="text-right">اطلاعاتی یافت نشد</p>
                      </template>
                      <template slot="Action" slot-scope="props">
                        <a
                          href="javascript:;"
                          class="mr-2 badge"
                          :disabled="!EditMode"
                          @click="OnDelete(props.row)"
                        >
                          <span
                            class="fa fa-trash-alt text-secondary hover-danger"
                            style="font-size: 15px"
                          ></span>
                        </a>
                      </template>
                    </vue-bootstrap4-table>
                    </div>
                  </div>

                  <div v-else id="addAccountBank">
                    <div class="sv-fields">
                      <label class="sv-field sv-f--md">
                        <span class="sv-label">
                          از مبلغ تسهیلات
                          <span class="sv-unit">{{ $GetVahedPool() }}</span>
                        </span>
                        <input
                          class="3ragham"
                          :disabled="!EditMode"
                          @keyup="$PutCommatoInput()"
                          type="text"
                          v-model="
                            DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz
                          "
                        />
                      </label>
                      <label class="sv-field sv-f--md">
                        <span class="sv-label">
                          تا مبلغ تسهیلات
                          <span class="sv-unit">{{ $GetVahedPool() }}</span>
                        </span>
                        <input
                          class="3ragham"
                          :disabled="!EditMode"
                          @keyup="$PutCommatoInput()"
                          type="text"
                          v-model="
                            DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa
                          "
                        />
                      </label>
                      <label class="sv-field sv-f--xs">
                        <span class="sv-label">تعداد ضامنین</span>
                        <input
                          :disabled="!EditMode"
                          dir="ltr"
                          maxlength="1"
                          type="text"
                          v-model="
                            DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad
                          "
                        />
                      </label>
                      <label class="sv-field sv-f--xs">
                        <span class="sv-label">سقف تعداد ضمانت ضامنین</span>
                        <input
                          dir="ltr"
                          maxlength="1"
                          type="number"
                          v-model="
                            DataModelSetting.WwwtblNoeZamenPolicyOnline
                              .MaxCountForZemanat
                          "
                        />
                      </label>
                    </div>
                    <div class="sv-toggles sv-toggles--inline">
                      <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                        <span class="sv-switch">
                          <input
                            type="checkbox"
                            id="IsOzv"
                            :disabled="!EditMode"
                            v-model="
                              DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv
                            "
                          />
                          <span class="sv-switch__track" aria-hidden="true"></span>
                        </span>
                        <span class="sv-toggle__text">
                          الزام به بررسی عضویت ضامن
                        </span>
                      </label>
                      <label class="sv-toggle" :class="{ 'is-disabled': !EditMode }">
                        <span class="sv-switch">
                          <input
                            type="checkbox"
                            id="WwwtblNoeZamenPolicyOnlineIsUpload"
                            :disabled="!EditMode"
                            v-model="
                              DataModelSetting.WwwtblNoeZamenPolicyOnline
                                .IsUpload
                            "
                          />
                          <span class="sv-switch__track" aria-hidden="true"></span>
                        </span>
                        <span class="sv-toggle__text">
                          الزام به بارگذاری مدارک ضامن
                        </span>
                      </label>
                    </div>
                    <div
                      v-if="Isgrid == false && addZamen == true"
                      class="sv-actions"
                    >
                      <button
                        type="button"
                        class="sv-btn sv-btn--ghost"
                        :disabled="!EditMode"
                        @click="addZamen = false"
                      >
                        لغو
                      </button>
                      <button
                        type="button"
                        class="sv-btn sv-btn--primary"
                        :disabled="!EditMode"
                        @click="submitAddZamen()"
                      >
                        ثبت
                      </button>
                    </div>
                    <div
                      v-if="Isgrid == true && addZamen == true"
                      class="sv-actions"
                    >
                      <button
                        type="button"
                        class="sv-btn sv-btn--ghost"
                        :disabled="!EditMode"
                        @click="addZamen = false"
                      >
                        لغو
                      </button>
                      <button
                        type="button"
                        class="sv-btn sv-btn--primary"
                        :disabled="!EditMode"
                        @click="addgridZamen()"
                      >
                        اضافه به لیست
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="addZamen != true" class="sv-footer">
              <button
                v-if="EditMode && IsSetting"
                type="button"
                class="sv-btn sv-btn--ghost sv-btn--wide"
                @click="CancelEdit"
              >
                انصراف
              </button>
              <button
                v-if="EditMode"
                type="button"
                class="sv-btn sv-btn--primary sv-btn--wide"
                @click="SaveData"
              >
                ثبت اطلاعات
              </button>
              <button
                v-else
                type="button"
                class="sv-btn sv-btn--primary sv-btn--wide"
                @click="EditMode = !EditMode"
              >
                اصلاح
              </button>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Panel, NetPaCard, NetPaTab, VueBootstrap4Table, Treeselect },
  data() {
    return {
      options: [],
      optionsDarsad: [],
      optionsMax: [],
      value: null,
      valueMax: null,
      valueDarsad: null,
      valueTashilatNotMojaz: null,
      rows: [],
      columns: [
        { label: "id", name: "id", visibility: false },
        { label: "از مبلغ تسهیلات", name: "mabAz" },
        { label: "تا مبلغ تسهیلات", name: "mabTa" },
        { label: "تعداد ضامنین ", name: "tedad" },
        { label: "سقف تعداد ضمانت ضامنین ", name: "maxCountForZemanat" },
        { label: "عضویت ضامن", name: "isOzv" },
        { label: "الزام بارگذاری مدارک", name: "isUpload", visibility: true },
        { label: "شرایط بارگذاری مدارک", name: "desUpload", visibility: false },
        {
          label: "عملیات",
          name: "Action",
          visibility: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "  جستجو   ",
          visibility: false,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      addZamen: false,
      svOpenSection: "permits",
      EditMode: false,
      Isgrid: false,
      DataModelSetting: {
        IsActive: true,
        MinMablagh: 0,
        MaxMablagh: 0,
        MinTedad: 1,
        MaxTedad: 36,
        MaxBedeh: 0,
        MaxTedadGhestBedeh: 0,
        MaxBodjeMahane: 0,
        AzDay: 1,
        TaDay: 31,
        IsUpload: false,
        TblNoeIdPas: -1,
        SabeghehOzviyat: 0,
        MinMojodiPas: 0,
        DesUpload: "",
        Des: "",
        IsSafteElectronic: false,
        Isformula: false,
        WwwtblNoeId: 0,
        BnpCashDbtblNoeId: 0,
        WwwtblNoeZamenPolicyOnline: {
          MabAz: 0,
          MabTa: 0,
          Tedad: 1,
          IsOzv: true,
          IsUpload: false,
          DesUpload: "",
          MaxCountForZemanat: 0,
        },
        tblNoeIdEqual: -1,
        Equal: null,
        ischeckupMandeAllTaahodat: false,
        MinMahAzTasvieHaminNoe: null,
        IsMohasebeZodkardDirKardAxarinGhest: false,
        MinDarsadAzTasvieHaminNoe: null,
        IsFixInputMablaghVam: false,
        tblNoeIdsNotMojaz: null,
      },
      SelectedVam: {},
      IsSetting: false,
      DataAxiosGetNoeVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetTblNoe",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosSettingVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetSettingVam",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosZamenPolicy: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetZamenPolicyOnline",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosAddZamenPolicy: {
        ArryfildValue: {},
        Method: "Post",
        Action: "RequestVamNew/InsZamenPolicy",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SaveData: {
        ArryfildValue: {},
        Method: "Post",
        Action: "RequestVamNew/InsSettingVam",
        Token: this.$session.get("TokenNetPa"),
      },
      Vamha: [],
      Hesabha: [],
      DataAxiosDelete: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/DeleteZamenPolicy",
        Token: this.$session.get("TokenNetPa"),
      },
      IsFormulEqual: this.$session.get("CustCode") == 932 ? true : false,
      IsFormulEqualMin: false,
      IsFormulEqualMax: false,
      IsFormolMaxBedehi: false,
      IsFormolEqualhoghogh: false,
      copyGeneral: true,
      copyZamen: true,
      copyTargets: [],
      copyBusy: false,
    };
  },
  computed: {
    copyCandidates() {
      return (this.Vamha || []).filter((item) => item.id != this.SelectedVam.id);
    },
  },
  methods: {
    toggleSvSection(id) {
      this.svOpenSection = this.svOpenSection === id ? "" : id;
    },
    SaveData() {
      if (!this.$ValidForm("nav-tabContent")) {
        return;
      }
      // console.log(this.SelectedVam);
      const WwwtblNoeZamenPolicyOnline = [];
      WwwtblNoeZamenPolicyOnline.push({
        MabAz:
          this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz != ""
            ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(
                /,/g,
                "",
              ).replace(/\./g, "")
            : 0,
        MabTa:
          this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa != ""
            ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(
                /,/g,
                "",
              ).replace(/\./g, "")
            : 0,
        Tedad: Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad),
        IsOzv: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv,
        IsUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload,
        DesUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload,
        MaxCountForZemanat:
          this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MaxCountForZemanat,
      });

      // console.log(typeof(this.DataModelSetting.MinMojodiPas))
      this.DataAxios_SaveData.ArryfildValue.AzDay = Number(
        this.DataModelSetting.AzDay,
      );
      this.DataAxios_SaveData.ArryfildValue.BnpCashDbtblNoeId =
        this.DataModelSetting.BnpCashDbtblNoeId;
      this.DataAxios_SaveData.ArryfildValue.Des = this.DataModelSetting.Des;
      this.DataAxios_SaveData.ArryfildValue.DesUpload =
        this.DataModelSetting.DesUpload;
      this.DataAxios_SaveData.ArryfildValue.IsActive =
        this.DataModelSetting.IsActive;
      this.DataAxios_SaveData.ArryfildValue.IsSafteElectronic =
        this.DataModelSetting.IsSafteElectronic;
      this.DataAxios_SaveData.ArryfildValue.IsUpload =
        this.DataModelSetting.IsUpload;
      this.DataAxios_SaveData.ArryfildValue.Isformula =
        this.DataModelSetting.Isformula;
      this.DataAxios_SaveData.ArryfildValue.TaDay = Number(
        this.DataModelSetting.TaDay,
      );
      this.DataAxios_SaveData.ArryfildValue.MinTedad = Number(
        this.DataModelSetting.MinTedad,
      );
      this.DataAxios_SaveData.ArryfildValue.MaxTedad = Number(
        this.DataModelSetting.MaxTedad,
      );
      this.DataAxios_SaveData.ArryfildValue.SabeghehOzviyat = Number(
        this.DataModelSetting.SabeghehOzviyat,
      );
      this.DataAxios_SaveData.ArryfildValue.MinMablagh =
        this.DataModelSetting.MinMablagh != ""
          ? this.DataModelSetting.MinMablagh.replace(/,/g, "").replace(
              /\./g,
              "",
            )
          : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxMablagh =
        this.DataModelSetting.MaxMablagh != ""
          ? this.DataModelSetting.MaxMablagh.replace(/,/g, "").replace(
              /\./g,
              "",
            )
          : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxBedeh =
        this.DataModelSetting.MaxBedeh != "" && this.IsFormolMaxBedehi == false
          ? this.DataModelSetting.MaxBedeh.replace(/,/g, "").replace(/\./g, "")
          : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxTedadGhestBedehi =
        this.DataModelSetting.MaxTedadGhestBedeh != 0 &&
        this.IsFormolMaxBedehi == true
          ? this.DataModelSetting.MaxTedadGhestBedeh
          : 0;
      this.DataAxios_SaveData.ArryfildValue.MaxBodjeMahane =
        this.DataModelSetting.MaxBodjeMahane != ""
          ? this.DataModelSetting.MaxBodjeMahane.replace(/,/g, "").replace(
              /\./g,
              "",
            )
          : 0;
      this.DataAxios_SaveData.ArryfildValue.MinMojodiPas =
        this.DataModelSetting.MinMojodiPas != ""
          ? this.DataModelSetting.MinMojodiPas.replace(/,/g, "").replace(
              /\./g,
              "",
            )
          : 0;
      this.DataAxios_SaveData.ArryfildValue.TblNoeIdPas =
        this.DataModelSetting.TblNoeIdPas?.id;
      this.DataAxios_SaveData.ArryfildValue.WwwtblNoeId =
        this.DataModelSetting.WwwtblNoeId;
      this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqual =
        this.DataModelSetting.tblNoeIdEqual;
      this.DataAxios_SaveData.ArryfildValue.Equal = this.DataModelSetting.Equal;
      this.DataAxios_SaveData.ArryfildValue.EqualHoghogh =
        this.DataModelSetting.EqualHoghogh;
      this.DataAxios_SaveData.ArryfildValue.WwwtblNoeZamenPolicyOnline =
        this.rows.lenght == 0 ? WwwtblNoeZamenPolicyOnline : this.rows;
      this.DataAxios_SaveData.ArryfildValue.ischeckupMandeAllTaahodat =
        this.DataModelSetting.ischeckupMandeAllTaahodat;

      this.DataAxios_SaveData.ArryfildValue.tblnoeEftetahHesab =
        this.DataModelSetting.tblnoeEftetahHesab == -1
          ? null
          : this.DataModelSetting.tblnoeEftetahHesab;
      this.DataAxios_SaveData.ArryfildValue.MinMahAzEftetahHesab =
        this.DataModelSetting.MinMahAzEftetahHesab == null ||
        this.DataModelSetting.MinMahAzEftetahHesab == 0
          ? null
          : this.DataModelSetting.MinMahAzEftetahHesab;
      this.DataAxios_SaveData.ArryfildValue.MinMahAzTasvieHaminNoe =
        this.DataModelSetting.MinMahAzTasvieHaminNoe == 0 ||
        this.DataModelSetting.MinMahAzTasvieHaminNoe == null
          ? null
          : Number(this.DataModelSetting.MinMahAzTasvieHaminNoe);
      this.DataAxios_SaveData.ArryfildValue.MinDarsadAzTasvieHaminNoe =
        this.DataModelSetting.MinDarsadAzTasvieHaminNoe == "" ||
        this.DataModelSetting.MinDarsadAzTasvieHaminNoe == null
          ? null
          : parseInt(this.DataModelSetting.MinDarsadAzTasvieHaminNoe);
      this.DataAxios_SaveData.ArryfildValue.IsMohasebeZodkardDirKardAxarinGhest =
        this.DataModelSetting.MinMahAzTasvieHaminNoe == 0 ||
        this.DataModelSetting.MinMahAzTasvieHaminNoe == null
          ? null
          : this.DataModelSetting.IsMohasebeZodkardDirKardAxarinGhest;
      this.DataAxios_SaveData.ArryfildValue.IsFixInputMablaghVam =
        this.DataModelSetting.IsFixInputMablaghVam;
      let str = "";
      let strMax = "";
      let strDarsad = "";
      let strTashilatNotMojaz = "";

      if (this.IsFormulEqualMin == true) {
        this.value.forEach((val) => {
          str = str + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMin = str;
        this.DataAxios_SaveData.ArryfildValue.EqualMin =
          this.DataModelSetting.EqualMin;
        this.DataAxios_SaveData.ArryfildValue.MinMablagh = 0;
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMin = null;
        this.DataAxios_SaveData.ArryfildValue.EqualMin = null;
      }

      if (this.IsFormulEqualMax == true) {
        this.valueMax.forEach((val) => {
          strMax = strMax + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMax = strMax;
        this.DataAxios_SaveData.ArryfildValue.EqualMax =
          this.DataModelSetting.EqualMax;
        this.DataAxios_SaveData.ArryfildValue.MaxMablagh = 0;
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdEqualListMax = null;
        this.DataAxios_SaveData.ArryfildValue.EqualMax = null;
      }

      if (
        this.valueDarsad != null &&
        this.valueDarsad.length > 0 &&
        parseInt(this.DataModelSetting.MinDarsadAzTasvieHaminNoe)
      ) {
        this.valueDarsad.forEach((val) => {
          strDarsad = strDarsad + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdDarsadAzTasvieList =
          strDarsad.slice(0, -1);
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdDarsadAzTasvieList = null;
      }

      if (
        this.valueTashilatNotMojaz != null &&
        this.valueTashilatNotMojaz.length > 0
      ) {
        this.valueTashilatNotMojaz.forEach((val) => {
          strTashilatNotMojaz = strTashilatNotMojaz + val + ",";
        });
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdsNotMojaz =
          strTashilatNotMojaz.slice(0, -1);
      } else {
        this.DataAxios_SaveData.ArryfildValue.tblNoeIdsNotMojaz = null;
      }

      this.$PostData(this.DataAxios_SaveData)
        .then((data) => {
          if (data.status == "OK") {
            this.$mySweetDefault(
              "عملیات موفق",
              "ثبت تنظیمات با موفقیت انجام شد",
              "success",
              2000,
            );
            this.EditMode = !this.EditMode;
          } else {
            this.$mySweetDefault(
              "عملیات ناموفق",
              "ثبت تنظیمات با مشکل مواجه شد",
              "warning",
              2000,
            );
            this.EditMode = !this.EditMode;
          }
        })
        .finally(() => {
          this.GetNoeVam();
        });
    },
    CancelEdit() {
      // discard unsaved edits: reload the saved values and leave edit mode
      this.addZamen = false;
      this.value = null;
      this.valueMax = null;
      this.valueTashilatNotMojaz = null;
      this.GetSettingVam();
    },
    openModal() {
      $("#Modal-Setting").modal("show");
    },
    closeModal() {
      $("#Modal-Setting").modal("hide");
    },
    GetNoeVam() {
      // Object.assign(this.$data, this.$options.data.call(this));

      var formdata = new FormData();
      formdata.append("id", 1);
      this.DataAxiosGetNoeVam.ArryfildValue = formdata;
      this.$PostFormData(this.DataAxiosGetNoeVam)
        .then((data) => {
          // console.log(data);

          this.Vamha = data;
          this.pushToValuesForTree();
        })
        .finally(() => {
          this.openModal();
        });
    },
    GetNoePas() {
      var formdata = new FormData();
      formdata.append("id", 2);
      this.DataAxiosGetNoeVam.ArryfildValue = formdata;
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Hesabha = data;
        this.pushToValuesForTree();
      });
    },
    pushToValuesForTree() {
      let list = [];
      this.Hesabha.forEach((data) => {
        data["label"] = data.desNoe;
        list.push(data);
      });
      this.options = list;
      this.optionsMax = list;

      let list2 = [];
      this.Vamha.forEach((data) => {
        data["label"] = data.desNoe;
        list2.push(data);
      });
      this.optionsDarsad = list2;
    },
    seLectVam(data) {
      this.closeModal();
      // switching vam mid-edit: leave edit mode so the button is back to "اصلاح"
      this.EditMode = false;
      this.SelectedVam = data;
      if (this.SelectedVam.id > 0) {
        this.DataModelSetting.BnpCashDbtblNoeId =
          this.SelectedVam.bnpCashDbtblNoeId;
        this.DataModelSetting.WwwtblNoeId = this.SelectedVam.id;
        this.GetSettingVam();
      }
    },
    ResetSettingForm() {
      // clear every field so values of a previously selected vam never leak
      // into a vam that has no saved settings
      const defaults = this.$options.data.call(this);
      const keepWwwtblNoeId = this.DataModelSetting.WwwtblNoeId;
      const keepBnpCashDbtblNoeId = this.DataModelSetting.BnpCashDbtblNoeId;
      this.DataModelSetting = {
        ...defaults.DataModelSetting,
        Id: null,
        EqualMin: null,
        EqualMax: null,
        EqualHoghogh: null,
        tblnoeEftetahHesab: -1,
        MinMahAzEftetahHesab: 0,
        WwwtblNoeId: keepWwwtblNoeId,
        BnpCashDbtblNoeId: keepBnpCashDbtblNoeId,
      };
      this.value = null;
      this.valueMax = null;
      this.valueDarsad = null;
      this.valueTashilatNotMojaz = null;
      this.IsFormulEqual = false;
      this.IsFormulEqualMin = false;
      this.IsFormulEqualMax = false;
      this.IsFormolMaxBedehi = false;
      this.IsFormolEqualhoghogh = false;
      this.addZamen = false;
    },
    GetSettingVam() {
      this.rows = [];
      var formdata = new FormData();
      formdata.append("id", this.SelectedVam.id);
      this.DataAxiosSettingVam.ArryfildValue = formdata;
      this.$PostFormData(this.DataAxiosSettingVam)
        .then((data) => {
          //this.Vamha = data
          this.ResetSettingForm();
          if (data != null && data.isActive == true) {
            this.IsSetting = true;
            this.EditMode = false;
            this.Isgrid = false;
            this.DataModelSetting.Id = data.id;
            // this.DataModelSetting.WwwtblNoeId=data.wwwtblNoeId
            // this.DataModelSetting.BnpCashDbtblNoeId=data.bnpCashDbtblNoeId
            this.DataModelSetting.IsActive = data.isActive;
            this.DataModelSetting.Isformula = data.isformula;
            this.DataModelSetting.IsSafteElectronic = data.isSafteElectronic;
            this.DataModelSetting.MinMablagh = this.$Comma3ragham(
              data.minMablagh,
            );
            this.DataModelSetting.MaxMablagh = this.$Comma3ragham(
              data.maxMablagh,
            );
            this.DataModelSetting.MinTedad = data.minTedad;
            this.DataModelSetting.MaxTedad = data.maxTedad;
            this.DataModelSetting.MaxBedeh = this.$Comma3ragham(data.maxBedeh);
            this.DataModelSetting.AzDay = data.azDay;
            this.DataModelSetting.TaDay = data.taDay;
            this.DataModelSetting.MaxBodjeMahane = this.$Comma3ragham(
              data.maxBodjeMahane,
            );
            this.DataModelSetting.MinMojodiPas = this.$Comma3ragham(
              data.minMojodiPas,
            );
            this.DataModelSetting.SabeghehOzviyat = data.sabeghehOzviyat;
            this.DataModelSetting.Des = data.des;
            this.DataModelSetting.IsUpload = data.isUpload;
            this.DataModelSetting.DesUpload = data.desUpload;
            this.DataModelSetting.TblNoeIdPas = data.tblNoeIdPas;
            this.DataModelSetting.ischeckupMandeAllTaahodat =
              data.ischeckupMandeAllTaahodat;
            this.DataModelSetting.MaxTedadGhestBedeh = data.maxTedadGhestBedehi;
            this.DataModelSetting.MinMahAzTasvieHaminNoe =
              data.minMahAzTasvieHaminNoe;
            this.DataModelSetting.IsMohasebeZodkardDirKardAxarinGhest =
              data.isMohasebeZodkardDirKardAxarinGhest;
            this.DataModelSetting.IsFixInputMablaghVam =
              data.isFixInputMablaghVam;
            if (
              data.equal > 0 &&
              data.equal != null &&
              data.tblNoeIdEqual != null &&
              data.tblNoeIdEqual != -1
            ) {
              this.IsFormulEqual = true;
            } else {
              this.IsFormulEqual = false;
            }
            if (
              data.equalMin > 0 &&
              data.equalMin != null &&
              data.tblNoeIdEqualListMin != null &&
              data.tblNoeIdEqualListMin != ""
            ) {
              this.IsFormulEqualMin = true;
              this.value = data.tblNoeIdEqualListMin.slice(0, -1).split(",");
            } else {
              this.IsFormulEqualMin = false;
            }

            if (
              data.equalMax > 0 &&
              data.equalMax != null &&
              data.tblNoeIdEqualListMax != null &&
              data.tblNoeIdEqualListMax != ""
            ) {
              this.IsFormulEqualMax = true;
              this.valueMax = data.tblNoeIdEqualListMax.slice(0, -1).split(",");
            } else {
              this.IsFormulEqualMax = false;
            }
            if (
              data.minDarsadAzTasvieHaminNoe > 0 &&
              data.minDarsadAzTasvieHaminNoe != null &&
              data.tblNoeIdDarsadAzTasvieList != null &&
              data.tblNoeIdDarsadAzTasvieList != ""
            ) {
              this.DataModelSetting.MinDarsadAzTasvieHaminNoe =
                data.minDarsadAzTasvieHaminNoe;
              this.valueDarsad = data.tblNoeIdDarsadAzTasvieList.split(",");
            } else {
              this.DataModelSetting.MinDarsadAzTasvieHaminNoe = null;
              this.valueDarsad = null;
            }
            if (data.maxTedadGhestBedehi > 0) {
              this.IsFormolMaxBedehi = true;
            } else {
              this.IsFormolMaxBedehi = false;
            }

            if (data.equalHoghogh > 0 && data.equalHoghogh != null) {
              this.IsFormolEqualhoghogh = true;
            } else {
              this.IsFormolEqualhoghogh = false;
            }

            if (data.tblNoeIdsNotMojaz != null) {
              this.DataModelSetting.tblNoeIdsNotMojaz = data.tblNoeIdsNotMojaz;
              this.valueTashilatNotMojaz = data.tblNoeIdsNotMojaz.split(",");
            }

            this.DataModelSetting.tblNoeIdEqual = data.tblNoeIdEqual;
            this.DataModelSetting.Equal = data.equal;
            this.DataModelSetting.EqualMin = data.equalMin;
            this.DataModelSetting.EqualMax = data.equalMax;
            this.DataModelSetting.EqualHoghogh = data.equalHoghogh;
            this.DataModelSetting.tblnoeEftetahHesab =
              data.tblnoeEftetahHesab == null ? -1 : data.tblnoeEftetahHesab;
            this.DataModelSetting.MinMahAzEftetahHesab =
              data.minMahAzEftetahHesab == null ? 0 : data.minMahAzEftetahHesab;
            this.DataModelSetting.IsFixInputMablaghVam =
              data.isFixInputMablaghVam;
          } else {
            this.IsSetting = false;
            this.EditMode = false;
            this.rows = [];
            this.Isgrid = true;
            this.IsFormulEqual = false;
            this.IsFormulEqualMin = false;
            this.IsFormulEqualMax = false;
            // this.DataModelSetting = {
            //   IsActive: false,
            //   MinMablagh: 0,
            //   MaxMablagh: 0,
            //   MinTedad: 1,
            //   MaxTedad: 36,
            //   MaxBedeh: 0,
            //   MaxBodjeMahane: 0,
            //   AzDay: 1,
            //   TaDay: 31,
            //   IsUpload: false,
            //   TblNoeIdPas: -1,
            //   SabeghehOzviyat: 0,
            //   MinMojodiPas: 0,
            //   DesUpload: '',
            //   Des: '',
            //   IsSafteElectronic: false,
            //   Isformula: false,
            //   WwwtblNoeId: 0,
            //   BnpCashDbtblNoeId: 0,
            //   WwwtblNoeZamenPolicyOnline: {
            //     MabAz: 0,
            //     MabTa: 0,
            //     Tedad: 1,
            //     IsOzv: true,
            //     IsUpload: false,
            //     DesUpload: '',
            //     MaxCountForZemanat: 0,
            //   },
            //   tblNoeIdEqual: -1,
            //   Equal: null,
            //   ischeckupMandeAllTaahodat: false,
            // }
          }
        })
        .finally(() => {
          if (!this.DataModelSetting.Id) {
            this.rows = [];
            this.GetNoePas();
            return;
          }
          var formdata = new FormData();
          formdata.append("id", this.DataModelSetting.Id);
          this.DataAxiosZamenPolicy.ArryfildValue = formdata;
          this.$PostFormData(this.DataAxiosZamenPolicy)
            .then((res) => {
              // console.log('*/*/*',res);
              if (res != null) this.rows = res;
              else this.rows = [];
            })
            .finally(() => {
              this.GetNoePas();
            });
        });
    },
    ChangeNoe() {
      //this.DataModelSetting.TblNoeIdPas = this.DataModelSetting.TblNoeIdPas.id;
      if (this.DataModelSetting.TblNoeIdPas == -1) {
        this.DataModelSetting.MinMojodiPas = 0;
      }
    },
    ChangeNoeEftetahHesab() {
      // this.DataModelSetting.tblnoeEftetahHesab = this.DataModelSetting.tblnoeEftetahHesab.id
    },
    ChangeTblNoeEquals() {
      if (
        this.DataModelSetting.tblNoeIdEqual > 0 &&
        this.DataModelSetting.Equal > 0
      ) {
        this.DataModelSetting.MaxMablagh = 0;
      } else {
        this.DataModelSetting.tblNoeIdEqual = null;
        this.DataModelSetting.Equal = null;
      }
    },
    ChangeChkTblNoeEqual(e, IsFormulEqual) {
      if (IsFormulEqual == false) {
        this.DataModelSetting.tblNoeIdEqual = null;
        this.DataModelSetting.Equal = null;
        this.DataModelSetting.MaxMablagh = this.DataModelSetting.MinMablagh;
      }
    },
    ChangeChkMinMaxMablagh(e, IsMin) {
      if (IsMin == false) {
        if (this.IsFormulEqualMax == false) {
          this.DataModelSetting.tblNoeIdEqualListMax = null;
          // this.DataModelSetting.MaxMablagh = this.DataModelSetting.MinMablagh
        }
      }
      if (IsMin == true) {
        if (this.IsFormulEqualMin == false) {
          this.DataModelSetting.tblNoeIdEqualListMin = null;
        }
      }
    },
    submitAddZamen() {
      this.DataAxiosAddZamenPolicy.ArryfildValue.MabAz =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz != ""
          ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(
              /,/g,
              "",
            ).replace(/\./g, "")
          : 0;
      this.DataAxiosAddZamenPolicy.ArryfildValue.MabTa =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa != ""
          ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(
              /,/g,
              "",
            ).replace(/\./g, "")
          : 0;
      this.DataAxiosAddZamenPolicy.ArryfildValue.Tedad = Number(
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad,
      );
      this.DataAxiosAddZamenPolicy.ArryfildValue.IsOzv =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv;
      this.DataAxiosAddZamenPolicy.ArryfildValue.DesUpload =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload;
      this.DataAxiosAddZamenPolicy.ArryfildValue.IsUpload =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload;
      this.DataAxiosAddZamenPolicy.ArryfildValue.MaxCountForZemanat =
        this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MaxCountForZemanat;
      this.DataAxiosAddZamenPolicy.ArryfildValue.WwwtblSettingVamOnlineId =
        this.DataModelSetting.Id;

      this.$PostData(this.DataAxiosAddZamenPolicy)
        .then((data) => {
          if (data.status == "OK") {
            this.$mySweetDefault(
              "عملیات موفق",
              "ثبت تنظیمات ضمانت با موفقیت انجام شد",
              "success",
              2000,
            );
            this.addZamen = false;
          }
        })
        .finally(() => {
          var formdata = new FormData();
          formdata.append("id", this.DataModelSetting.Id);
          this.DataAxiosZamenPolicy.ArryfildValue = formdata;
          this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
            if (res != null) this.rows = res;
            else this.rows = [];
          });
        });
    },
    OnDelete(row) {
      if (this.Isgrid) {
        for (let index = 0; index < this.rows.length; index++) {
          if (this.rows[index].id == row.id) {
            this.rows.splice(index, 1);
          }
        }
      } else {
        const formData = new FormData();
        formData.append("id", row.id);
        this.DataAxiosDelete.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosDelete)
          .then((data) => {
            if (data.status == "OK") {
              this.$mySweetDefault(
                "حذف موفق",
                "تنظیمات ضامن با موفقیت حذف شد",
                "success",
                2000,
              );
            }
          })
          .finally(() => {
            var formdata = new FormData();
            formdata.append("id", this.DataModelSetting.Id);
            this.DataAxiosZamenPolicy.ArryfildValue = formdata;
            this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
              if (res != null) this.rows = res;
              else this.rows = [];
            });
          });
      }
    },
    openCopyModal() {
      this.copyGeneral = true;
      this.copyZamen = true;
      this.copyTargets = [];
      this.copyBusy = false;
      $("#Modal-Copy-Setting").modal("show");
    },
    selectAllCopyTargets() {
      this.copyTargets = this.copyCandidates.map((item) => item.id);
    },
    clearCopyTargets() {
      this.copyTargets = [];
    },
    escapeCopyText(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    async submitCopy() {
      if (this.copyBusy) return;
      if (!this.copyGeneral && !this.copyZamen) {
        this.$mySweetDefault(
          "انتخاب نشده",
          "حداقل یکی از تنظیمات کلی یا شرایط ضامن را انتخاب کنید",
          "warning",
          2500,
        );
        return;
      }
      const selected = this.copyCandidates.filter((vam) =>
        this.copyTargets.some((id) => id == vam.id),
      );
      if (selected.length === 0) {
        this.$mySweetDefault(
          "انتخاب نشده",
          "حداقل یک وام مقصد را انتخاب کنید",
          "warning",
          2500,
        );
        return;
      }
      if (this.copyZamen && (!this.rows || this.rows.length === 0)) {
        const emptyConfirm = await this.$swal({
          title: "شرایط ضامن خالی است",
          text: "برای این وام ردیف شرایط ضامن ثبت نشده. با ادامه، ردیف‌های ضامن مقصد پاک می‌شود.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "ادامه",
          cancelButtonText: "انصراف",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        });
        if (!emptyConfirm.isConfirmed) return;
      }

      this.copyBusy = true;
      try {
        const checks = await Promise.all(
          selected.map(async (vam) => {
            const formdata = new FormData();
            formdata.append("id", vam.id);
            const data = await this.$PostFormData({
              ArryfildValue: formdata,
              Method: "Post",
              Action: "RequestVamNew/GetSettingVam",
              Token: this.$session.get("TokenNetPa"),
            });
            return { vam, data };
          }),
        );

        const withSetting = checks
          .filter((item) => item.data != null && item.data.isActive == true)
          .map((item) => item.vam);
        let replaceGeneral = false;
        if (this.copyGeneral && withSetting.length > 0) {
          const names = withSetting
            .map((vam) => this.escapeCopyText(vam.desNoe))
            .join("، ");
          const zamenNote = this.copyZamen
            ? "<br>شرایط ضامن وام‌هایی که تنظیمات کلی دارند، جدا از این تأیید جایگزین می‌شود."
            : "";
          const replaceConfirm = await this.$swal({
            title: "جایگزینی تنظیمات کلی",
            html:
              '<div class="text-right">برای این تسهیلات تنظیمات کلی وجود دارد:<br><b>' +
              names +
              "</b><br>با تأیید، تنظیمات کلی آن‌ها جایگزین می‌شود. با انصراف، تنظیمات کلی این موارد دست نمی‌خورد." +
              zamenNote +
              "</div>",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "جایگزین شود",
            cancelButtonText: "جایگزین نشود",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
          replaceGeneral = replaceConfirm.isConfirmed;
        }

        const destinations = [];
        const blocked = [];
        checks.forEach(({ vam, data }) => {
          const hasSetting = data != null && data.isActive == true;
          const item = {
            WwwtblNoeId: vam.id,
            CopyGeneral: false,
            CopyZamen: false,
          };
          if (this.copyGeneral && (!hasSetting || replaceGeneral)) {
            item.CopyGeneral = true;
          }
          if (this.copyZamen) {
            if (hasSetting || item.CopyGeneral) {
              item.CopyZamen = true;
            } else {
              blocked.push(vam.desNoe);
            }
          }
          if (item.CopyGeneral || item.CopyZamen) destinations.push(item);
        });

        if (destinations.length === 0) {
          const msg = blocked.length
            ? "این تسهیلات تنظیمات کلی ندارند و کپی شرایط ضامن برای آن‌ها انجام نشد: " +
              blocked.join("، ")
            : "موردی برای کپی باقی نماند.";
          this.$mySweetDefault("کپی انجام نشد", msg, "warning", 4000);
          return;
        }

        const result = await this.$PostData({
          ArryfildValue: {
            SourceWwwtblNoeId: this.SelectedVam.id,
            Destinations: destinations,
          },
          Method: "Post",
          Action: "RequestVamNew/CopySettingVam",
          Token: this.$session.get("TokenNetPa"),
        });

        if (result && (result.status == "OK" || result.Status == "OK")) {
          let msg = "کپی تنظیمات انجام شد.";
          if (blocked.length) {
            msg +=
              " برای این تسهیلات به‌خاطر نبود تنظیمات کلی، شرایط ضامن کپی نشد: " +
              blocked.join("، ");
          }
          this.$mySweetDefault(
            "عملیات موفق",
            msg,
            blocked.length ? "warning" : "success",
            4000,
          );
          $("#Modal-Copy-Setting").modal("hide");
        } else {
          this.$mySweetDefault(
            "عملیات ناموفق",
            (result && (result.message || result.Message)) ||
              "کپی تنظیمات انجام نشد",
            "warning",
            3000,
          );
        }
      } catch (e) {
        // خطای سرور در $PostData نمایش داده می‌شود
      } finally {
        this.copyBusy = false;
      }
    },
    addgridZamen() {
      this.rows.push({
        mabAz:
          this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz != ""
            ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(
                /,/g,
                "",
              ).replace(/\./g, "")
            : 0,
        mabTa:
          this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa != ""
            ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(
                /,/g,
                "",
              ).replace(/\./g, "")
            : 0,
        tedad: Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad),
        isOzv: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv,
        isUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload,
        desUpload: this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload,
        id: 1,
      });
      this.addZamen = false;
    },
  },
  mounted() {
    this.GetNoeVam();
  },
};
</script>
<style scoped>
/* ---------- tokens (NETPA_DESIGN_SYSTEM) ---------- */
.sv-page {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-success: #05a895;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-radius-md: 14px;
  --bnp-radius-lg: 20px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);

  --sv-control-h: 40px;

  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

/*
  این کارت یک فرم بلند است؛ افکت hover کارت (بالا آمدن و تغییر سایه‌ی بزرگ)
  هنگام اسکرول باعث بازترسیم مکرر کل کارت می‌شود، پس اینجا غیرفعال است.
*/
.sv-card,
.sv-card:hover {
  transform: none !important;
  transition: none !important;
}

/*
  NetPaCard با overflow:hidden گوشه‌های گرد را برش می‌دهد، ولی همین باعث می‌شود
  کارت خودش یک «scroll container» شود و چرخ ماوس/تاچ‌پد روی آن گیر کند.
  overflow:clip همان برش را انجام می‌دهد بدون اینکه کانتینر اسکرول بسازد
  (در مرورگرهای قدیمی که clip ندارند visible می‌شود و فقط برش گوشه‌ها نمی‌ماند).
*/
.sv-card.netpa-card,
.sv-card.bnp-rounded {
  overflow: visible !important;
  overflow: clip !important;
}

.sv-card:hover {
  box-shadow: 0 5px 18px rgba(31, 42, 79, 0.08) !important;
}

.sv-state {
  min-width: 0;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.sv-state.is-empty {
  color: var(--bnp-danger);
}

/* ---------- sections ---------- */
.sv-section {
  display: grid;
  grid-template-columns: 168px minmax(0, 1fr);
  gap: 12px 24px;
  padding: 18px 0;
  border-top: 1px solid var(--bnp-border-subtle);
}

.sv-section:first-child {
  padding-top: 0;
  border-top: 0;
}

.sv-section__title {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding-top: 2px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.8;
}

.sv-section__title i {
  flex: 0 0 16px;
  margin-top: 5px;
  color: var(--bnp-brand-indigo);
  font-size: 12px;
  text-align: center;
  opacity: 0.8;
}

.sv-section__chevron {
  display: none;
}

.sv-section > :not(.sv-section__title) {
  grid-column: 2;
  min-width: 0;
}

.sv-section > .sv-fields + .sv-fields {
  margin-top: 14px;
}

/* ---------- field rows ---------- */
.sv-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px 18px;
  min-width: 0;
}

.sv-rules {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sv-rule {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px 18px;
  min-width: 0;
}

.sv-rule__name {
  display: flex;
  align-items: center;
  flex: 0 0 188px;
  min-height: var(--sv-control-h);
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.6;
}

.sv-op {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-height: var(--sv-control-h);
  color: var(--bnp-text-secondary);
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.sv-op--strong {
  color: var(--bnp-brand-navy);
  font-weight: 800;
}

/* ---------- field ---------- */
.sv-field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 0 0 auto;
  gap: 6px;
  min-width: 0;
  margin: 0;
}

.sv-f--xs {
  --w: 84px;
}

.sv-f--md {
  --w: 172px;
}

.sv-f--lg {
  --w: 224px;
}

.sv-f--grow {
  flex: 1 1 280px;
  align-items: stretch;
}

.sv-label {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  white-space: nowrap;
}

.sv-f--grow > .sv-label {
  white-space: normal;
}

.sv-unit {
  margin-right: 4px;
  color: var(--bnp-brand-indigo);
}

.sv-field > input,
.sv-field > select {
  width: var(--w, 100%);
  max-width: 100%;
}

.sv-field input,
.sv-field select,
.sv-field textarea {
  box-sizing: border-box;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid var(--bnp-border-default);
  border-radius: 10px;
  background: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.sv-field input,
.sv-field select {
  height: var(--sv-control-h);
  padding: 0 10px;
}

.sv-field input {
  text-align: center;
}

.sv-field select {
  text-align: right;
  cursor: pointer;
}

.sv-field textarea {
  width: 100%;
  min-height: 76px;
  padding: 10px 12px;
  line-height: 1.8;
  text-align: right;
  resize: vertical;
}

.sv-field input:hover,
.sv-field select:hover,
.sv-field textarea:hover {
  border-color: var(--bnp-border-hover);
}

.sv-field input:focus,
.sv-field select:focus,
.sv-field textarea:focus {
  outline: none;
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.sv-field input:disabled,
.sv-field select:disabled,
.sv-field textarea:disabled {
  cursor: not-allowed;
  opacity: 0.75;
  background: #f3f6f8;
  border-color: var(--bnp-border-subtle);
}

.sv-field input.wronginput,
.sv-field select.wronginput,
.sv-field textarea.wronginput {
  border-color: var(--bnp-danger);
  box-shadow: 0 0 0 4px rgba(180, 79, 70, 0.16);
}

.sv-field input[type="number"]::-webkit-outer-spin-button,
.sv-field input[type="number"]::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.sv-field input[type="number"] {
  -moz-appearance: textfield;
}

.sv-inline {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sv-inline input {
  flex: 0 0 84px;
  width: 84px;
}

.sv-inline select {
  flex: 1 1 auto;
  min-width: 0;
}

/* treeselect */
.sv-field >>> .vue-treeselect__control {
  min-height: var(--sv-control-h);
  border-color: var(--bnp-border-default);
  border-radius: 10px;
  background: var(--bnp-surface-subtle);
}

.sv-field >>> .vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__control:hover {
  border-color: var(--bnp-border-hover);
}

.sv-field >>> .vue-treeselect--focused:not(.vue-treeselect--disabled) .vue-treeselect__control,
.sv-field >>> .vue-treeselect--open .vue-treeselect__control {
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.sv-field >>> .vue-treeselect--open {
  z-index: 40;
}

.sv-field >>> .vue-treeselect__placeholder,
.sv-field >>> .vue-treeselect__single-value,
.sv-field >>> .vue-treeselect__multi-value-label {
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 13px;
}

.sv-field >>> .vue-treeselect--disabled .vue-treeselect__control {
  cursor: not-allowed;
  opacity: 0.75;
  background: #f3f6f8;
}

/* ---------- switch / toggles / mode ---------- */
.sv-toggles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2px 20px;
}

.sv-toggles--inline {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 28px;
  margin-top: 14px;
}

.sv-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 36px;
  margin: 0;
  cursor: pointer;
}

.sv-toggle__text {
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
}

.sv-toggle.is-disabled,
.sv-mode.is-disabled,
.sv-check.is-disabled {
  cursor: default;
}

.sv-toggle.is-disabled .sv-toggle__text {
  color: #44566a;
}

.sv-mode {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 10px;
  min-height: var(--sv-control-h);
  margin: 0;
  cursor: pointer;
}

.sv-mode__side {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.sv-mode__side.is-active {
  color: var(--bnp-brand-navy);
  font-weight: 800;
}

.sv-switch {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  margin: 0;
}

.sv-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.sv-switch__track {
  position: relative;
  display: block;
  width: 36px;
  height: 20px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.sv-switch__track::after {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 14px;
  height: 14px;
  content: "";
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.sv-switch input:checked + .sv-switch__track {
  background: linear-gradient(110deg, var(--bnp-brand-navy), var(--bnp-brand-cyan));
}

.sv-switch input:checked + .sv-switch__track::after {
  transform: translateX(-16px);
}

.sv-switch input:focus-visible + .sv-switch__track {
  box-shadow: var(--bnp-focus-ring);
}

.sv-switch input:disabled + .sv-switch__track {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ---------- buttons ---------- */
.sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.sv-btn:focus {
  outline: none;
}

.sv-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.sv-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.sv-btn--sm {
  min-height: 34px;
  padding: 4px 12px;
  font-size: 12px;
}

.sv-btn--icon {
  width: var(--sv-control-h);
  padding: 0;
}

.sv-btn--ghost {
  color: var(--bnp-brand-navy);
  border: 1px solid var(--bnp-border-default);
  background: #fff;
}

.sv-btn--ghost:not(:disabled):hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

.sv-btn--primary:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
}

.sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

.sv-footer,
.sv-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.sv-actions {
  margin-top: 18px;
}

/* ---------- guarantor tab ---------- */
.sv-zamen {
  padding-bottom: 16px;
}

.sv-zamen__bar {
  display: flex;
  margin-bottom: 12px;
}

.sv-table {
  overflow: auto;
}

.sv-zamen-cards,
.sv-zamen-empty {
  display: none;
}

.sv-zamen-empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.sv-zamen-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 1rem 1.05rem 0.95rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.sv-zamen-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #e8eef2;
}

.sv-zamen-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.sv-zamen-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  color: #8a6414;
  font-size: 12px;
  font-weight: 800;
  border-radius: 999px;
  background: #fff4d6;
}

.sv-zamen-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.sv-zamen-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.sv-zamen-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.sv-zamen-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
}

.sv-zamen-card__field strong.is-on {
  color: #068997;
}

.sv-zamen-card__field strong.is-off {
  color: #8b98a8;
}

.sv-zamen-card__actions {
  display: flex;
  justify-content: flex-end;
}

.sv-zamen-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 34px;
  padding: 0.3rem 0.75rem;
  color: #b44f46;
  border: 1px solid #f0d4d1;
  border-radius: 10px;
  background: #fcefed;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.sv-zamen-chip:hover:not(:disabled),
.sv-zamen-chip:focus:not(:disabled) {
  color: #fff;
  border-color: #b44f46;
  background: #b44f46;
}

.sv-zamen-chip:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* ---------- modals ---------- */
.sv-modal .modal-content {
  overflow: hidden;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-lg);
  box-shadow:
    0 30px 80px rgba(15, 39, 68, 0.13),
    0 8px 24px rgba(15, 39, 68, 0.06);
}

.sv-modal__header {
  padding: 14px 18px;
  color: #fff;
  border-bottom: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
}

.sv-modal__header .modal-title {
  margin: 0;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.6;
}

.sv-modal__body {
  padding: 16px 18px 8px;
  text-align: right;
}

.sv-modal__lead,
.sv-hint {
  margin: 0 0 12px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  line-height: 1.8;
}

.sv-modal__footer {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  padding: 12px 18px 16px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.sv-pick-list,
.sv-copy-list,
.sv-copy-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sv-pick {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-md);
  background: #fff;
}

.sv-pick.is-selected {
  border-color: rgba(5, 168, 149, 0.35);
  background: rgba(5, 168, 149, 0.06);
}

.sv-pick__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.sv-pick__text strong {
  color: var(--bnp-text-primary);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.6;
}

.sv-pick__done {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--bnp-success);
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}

.sv-copy-options,
.sv-copy-list {
  margin-bottom: 14px;
  padding: 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
}

.sv-copy-list {
  max-height: 280px;
  overflow-y: auto;
}

.sv-copy-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 800;
}

.sv-copy-head__actions {
  display: flex;
  gap: 8px;
}

.sv-check {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.7;
  cursor: pointer;
}

.sv-check input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.sv-check__box {
  position: relative;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  border: 1px solid var(--bnp-border-hover);
  border-radius: 6px;
  background: #fff;
}

.sv-check input:checked + .sv-check__box {
  border-color: transparent;
  background: linear-gradient(145deg, var(--bnp-brand-cyan), var(--bnp-brand-purple));
}

.sv-check input:checked + .sv-check__box::after {
  position: absolute;
  top: 3px;
  right: 6px;
  width: 6px;
  height: 10px;
  content: "";
  border: solid #fff;
  border-width: 0 0 2px 2px;
  transform: rotate(-45deg);
}

.sv-check input:focus-visible + .sv-check__box {
  box-shadow: var(--bnp-focus-ring);
}

.sv-hint--empty {
  margin: 0;
}

@media (min-width: 576px) {
  .sv-modal .modal-dialog {
    max-width: 700px;
  }
}

/* ---------- responsive ---------- */
@media (max-width: 991px) {
  .sv-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .sv-section > :not(.sv-section__title) {
    grid-column: auto;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .sv-toggles {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .sv-toggle {
    justify-content: space-between;
    width: 100%;
  }

  .sv-toggle__text {
    flex: 1 1 auto;
    min-width: 0;
  }

  .sv-mode {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 10px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .sv-mode__side {
    flex: 1 1 7rem;
    min-width: 0;
    font-size: 12px;
    line-height: 1.6;
    white-space: normal;
  }

  .sv-mode .sv-switch {
    flex: 0 0 auto;
  }
}

@media (max-width: 767px) {
  .sv-page {
    --sv-control-h: 40px;
    overflow-x: hidden;
  }

  .sv-section {
    gap: 8px;
    padding: 8px 0;
  }

  .sv-section__title {
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 10px 2px;
    cursor: pointer;
  }

  .sv-section__title span {
    flex: 1 1 auto;
    min-width: 0;
  }

  .sv-section__chevron {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    color: #8b98a8;
    font-size: 11px;
    opacity: 1;
    transition: transform 180ms ease;
  }

  .sv-section.is-open .sv-section__chevron {
    transform: rotate(180deg);
  }

  .sv-section:not(.is-open) > :not(.sv-section__title) {
    display: none;
  }

  .sv-toggle {
    min-height: 36px;
    gap: 8px;
  }

  .sv-toggle__text {
    font-size: 12px;
  }

  .sv-footer {
    position: sticky;
    bottom: 0;
    z-index: 6;
    gap: 8px;
    width: 100%;
    margin: 8px 0 0;
    padding: 10px 0 0;
    background: #fff;
    box-sizing: border-box;
    box-shadow: none;
  }

  .sv-page > .row {
    margin-left: 0;
    margin-right: 0;
  }

  .sv-page > .row > [class*="col-"] {
    padding-left: 8px;
    padding-right: 8px;
  }

  .sv-card.netpa-card,
  .sv-card.bnp-rounded {
    width: 100%;
    max-width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
    overflow: hidden !important;
  }

  .sv-rule,
  .sv-rules {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    gap: 8px;
  }

  .sv-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    gap: 8px 10px;
  }

  .sv-fields .sv-field:not(.sv-f--xs) {
    grid-column: 1 / -1;
  }

  .sv-field,
  .sv-f--xs,
  .sv-f--md,
  .sv-f--lg,
  .sv-f--grow,
  .sv-fields--pair .sv-field {
    flex: none;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .sv-field > input,
  .sv-field > select {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .sv-label {
    white-space: normal;
  }

  .sv-rule__name {
    flex: none;
    width: 100%;
    min-height: 0;
  }

  .sv-inline {
    flex-wrap: wrap;
    width: 100%;
    max-width: 100%;
  }

  .sv-inline input {
    flex: 1 1 72px;
    width: auto;
    min-width: 72px;
    max-width: 100%;
  }

  .sv-footer .sv-btn,
  .sv-footer .sv-btn--wide,
  .sv-actions .sv-btn {
    flex: 1 1 0;
    min-width: 0;
  }

  .sv-pick {
    align-items: flex-start;
    flex-direction: column;
  }

  .sv-zamen-cards {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .sv-zamen-empty {
    display: block;
  }

  .sv-zamen-list .sv-table {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sv-btn,
  .sv-field input,
  .sv-field select,
  .sv-field textarea,
  .sv-switch__track,
  .sv-switch__track::after {
    transition: none;
  }

  .sv-btn--primary:not(:disabled):hover {
    transform: none;
  }
}
</style>
